import { render, staticRenderFns } from "./PostApply.vue?vue&type=template&id=28e0b2cc&scoped=true&"
import script from "./PostApply.vue?vue&type=script&lang=js&"
export * from "./PostApply.vue?vue&type=script&lang=js&"
import style0 from "./PostApply.vue?vue&type=style&index=0&id=28e0b2cc&lang=scss&scoped=true&"
import style1 from "./PostApply.vue?vue&type=style&index=1&id=28e0b2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0b2cc",
  null
  
)

export default component.exports